import { Col, Container, Row } from 'react-bootstrap'
import {
  ContentPanel,
  LoginImage,
  LogoImage,
  NewTabLink
} from '../../components'
import { Helmet } from 'react-helmet-async'
import { DEFAULT_ASSETS } from '../../helpers'
const { env } = window

const HomePage = () => {
  const {
    applicationName,
    imgSrcLogin,
    imgAltLogin,
    imgSrcLogo,
    imgAltLogo
  } = DEFAULT_ASSETS

  return (
    <Container className='resizing-container'>
      <Helmet>
        <title>Welcome - {applicationName}</title>
      </Helmet>
      <ContentPanel className='login-panel p-0'>
        <Row>
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 1 }}
            className='py-4 pl-5'
          >
            <LogoImage
              className='login-logo-img m-0 p-3 pb-4 w-75'
              fluid
              src={imgSrcLogo}
              alt={imgAltLogo}
            />
            <h1 className='h3 font-weight-bold pl-3'>{applicationName}</h1>
          </Col>
          <Col
            className='login-col-img pl-md-0'
            xs={{ span: 12, order: 0 }}
            md={{ span: 6, order: 2 }}
          >
            <LoginImage src={imgSrcLogin} alt={imgAltLogin} />
          </Col>
        </Row>
      </ContentPanel>
      <ContentPanel className='mb-5 p-5'>
        <div className='pb-3'>
          <h2 className='h5 pb-3 font-weight-bold'>Introducing the Portal</h2>
          <p>
            The <strong>Portal</strong> is a robust platform designed to
            streamline research project management, data organization, and
            collaboration within the academic and clinical research community.
            It serves as a centralized hub, enabling research teams to
            efficiently create and manage project portals, access data, and
            enhance team coordination—all within an intuitive and user-friendly
            interface.
          </p>
          <p>
            Developed and maintained by the{' '}
            <strong>Research Information Technology (RIT) </strong>
            team at the{' '}
            <strong>College of Medicine at The Ohio State University</strong>,
            in collaboration with the{' '}
            <strong>Clinical and Translational Science Institute (CTSI)</strong>
            , the Portal provides a seamless infrastructure to support
            initiatives.
          </p>
        </div>
        <div className='pb-3'>
          <h3 className='h6 pb-2 font-weight-bold'>
            What Can the Portal Do for You?
          </h3>
          <ul>
            <li>
              <strong>Simplified Project Management</strong> – Easily set up and
              oversee research projects, ensuring streamlined workflows and
              efficient collaboration.
            </li>
            <li>
              <strong>Data Access & Organization</strong> – Centralized tools
              for managing project data, improving accessibility, and ensuring
              data integrity.
            </li>
            <li>
              <strong>Customizable Research Portals</strong> – Adaptable
              interfaces designed to support the unique needs of different
              research teams.
            </li>
            <li>
              <strong>Seamless Collaboration</strong> – Facilitate engagement
              across teams by providing a structured communication and
              documentation environment.
            </li>
          </ul>
        </div>
        <div>
          <h3 className='h6 pb-2 font-weight-bold'>
            Getting Started with the Portal
          </h3>
          If you’re interested in leveraging the Portal for your research, we’re
          here to help! For any questions or additional information, please{' '}
          <NewTabLink url={env.contactUrl}>Contact Us</NewTabLink>
        </div>
      </ContentPanel>
    </Container>
  )
}

export { HomePage }
